














import 'reflect-metadata'; // Import only once
import { inject } from 'inversify-props';
import ConsentDialog from './consent/ConsentDialog';
import IAuthService from '../services/IAuthService';
import { Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';
import CoreDrawer from './core/Drawer';
import CoreAppBar from './core/AppBar';
import CoreView from './core/View';

@Component
export default class AppRoot extends Vue {
  @inject() authService: IAuthService;
  hasToken = false;
  renderLayout = true;

  async created() {
    this.$router.onReady(() => {
      this.renderLayout = this.$router.history.current.meta.isStandaloneView !== true;
    })

    Vue.component('core-view', CoreView);

    if (this.renderLayout) {
      Vue.component('core-drawer', CoreDrawer);
      Vue.component('core-app-bar', CoreAppBar);
      Vue.component('core-drawer', CoreDrawer);
      Vue.component('ConsentDialog', ConsentDialog);
    }

    this.hasToken = await this.authService.userHasToken();
  }
}
